<script>
const jsonLogicSchema = require("@axa-ch/json-logic-js/schemas/json-logic.json")
const CommonAllOperators = require("@axa-ch/json-logic-js/schemas/common/all-operators.json")
const CommonAllTypesWoArray = require("@axa-ch/json-logic-js/schemas/common/all-types-wo-array.json")
const CommonAllTypes = require("@axa-ch/json-logic-js/schemas/common/all-types.json")
const CommonAnyWoArray = require("@axa-ch/json-logic-js/schemas/common/any-wo-array.json")
const CommonAny = require("@axa-ch/json-logic-js/schemas/common/any.json")
const CommonBinaryArgs = require("@axa-ch/json-logic-js/schemas/common/binary-args.json")
const CommonNoLogicObject = require("@axa-ch/json-logic-js/schemas/common/no-logic-object.json")
const CommonOneOrMoreArgs = require("@axa-ch/json-logic-js/schemas/common/one-or-more-args.json")
const CommonPointer = require("@axa-ch/json-logic-js/schemas/common/pointer.json")
const CommonTrinaryArgs = require("@axa-ch/json-logic-js/schemas/common/trinary-args.json")
const CommonUnaryArgs = require("@axa-ch/json-logic-js/schemas/common/unary-arg.json")
const CommonVar = require("@axa-ch/json-logic-js/schemas/common/var.json")
const AccessorMissingSome = require("@axa-ch/json-logic-js/schemas/operators/accessor/missing_some.json")
const AccessorMissing = require("@axa-ch/json-logic-js/schemas/operators/accessor/missing.json")
const AccessorVariable = require("@axa-ch/json-logic-js/schemas/operators/accessor/variable.json")
const ArithmeticAdd = require("@axa-ch/json-logic-js/schemas/operators/arithmetic/add.json")
const ArithmeticDivide = require("@axa-ch/json-logic-js/schemas/operators/arithmetic/divide.json")
const ArithmeticModulo = require("@axa-ch/json-logic-js/schemas/operators/arithmetic/modulo.json")
const ArithmeticMultiply = require("@axa-ch/json-logic-js/schemas/operators/arithmetic/multiply.json")
const ArithmeticSubtract = require("@axa-ch/json-logic-js/schemas/operators/arithmetic/substract.json")
const ArrayAll = require("@axa-ch/json-logic-js/schemas/operators/array/all.json")
const ArrayFilter = require("@axa-ch/json-logic-js/schemas/operators/array/filter.json")
const ArrayMap = require("@axa-ch/json-logic-js/schemas/operators/array/map.json")
const ArrayMerge = require("@axa-ch/json-logic-js/schemas/operators/array/merge.json")
const ArrayNone = require("@axa-ch/json-logic-js/schemas/operators/array/none.json")
const ArrayReduce = require("@axa-ch/json-logic-js/schemas/operators/array/reduce.json")
const ArraySome = require("@axa-ch/json-logic-js/schemas/operators/array/some.json")
const LogicAnd = require("@axa-ch/json-logic-js/schemas/operators/logic/and.json")
const LogicEqual = require("@axa-ch/json-logic-js/schemas/operators/logic/equal.json")
const LogicIf = require("@axa-ch/json-logic-js/schemas/operators/logic/if.json")
const LogicNot = require("@axa-ch/json-logic-js/schemas/operators/logic/not.json")
const LogicNotEqual = require("@axa-ch/json-logic-js/schemas/operators/logic/notEqual.json")
const LogicNotNot = require("@axa-ch/json-logic-js/schemas/operators/logic/notnot.json")
const LogicOr = require("@axa-ch/json-logic-js/schemas/operators/logic/or.json")
const LogicStrictEqual = require("@axa-ch/json-logic-js/schemas/operators/logic/strictEqual.json")
const LogicStrictNotEqual = require("@axa-ch/json-logic-js/schemas/operators/logic/strictNotEqual.json")
const MiscIn = require("@axa-ch/json-logic-js/schemas/operators/misc/in.json")
const MiscLog = require("@axa-ch/json-logic-js/schemas/operators/misc/log.json")
const MiscMethod = require("@axa-ch/json-logic-js/schemas/operators/misc/method.json")
const NumericGreater = require("@axa-ch/json-logic-js/schemas/operators/numeric/greater.json")
const NumericGreaterEqual = require("@axa-ch/json-logic-js/schemas/operators/numeric/greaterEqual.json")
const NumericLess = require("@axa-ch/json-logic-js/schemas/operators/numeric/less.json")
const NumericLessEqual = require("@axa-ch/json-logic-js/schemas/operators/numeric/lessEqual.json")
const NumericMax = require("@axa-ch/json-logic-js/schemas/operators/numeric/max.json")
const NumericMin = require("@axa-ch/json-logic-js/schemas/operators/numeric/min.json")
const StringCat = require("@axa-ch/json-logic-js/schemas/operators/string/cat.json")
const StringSubstr = require("@axa-ch/json-logic-js/schemas/operators/string/substr.json")

var definitions = [
	CommonAllOperators,
	CommonAllTypesWoArray,
	CommonAllTypes,
	CommonAnyWoArray,
	CommonAny,
	CommonBinaryArgs,
	CommonNoLogicObject,
	CommonOneOrMoreArgs,
	CommonPointer,
	CommonTrinaryArgs,
	CommonUnaryArgs,
	CommonVar,
	AccessorMissingSome,
	AccessorMissing,
	AccessorVariable,
	ArithmeticAdd,
	ArithmeticDivide,
	ArithmeticModulo,
	ArithmeticMultiply,
	ArithmeticSubtract,
	ArrayAll,
	ArrayFilter,
	ArrayMap,
	ArrayMerge,
	ArrayNone,
	ArrayReduce,
	ArraySome,
	LogicAnd,
	LogicEqual,
	LogicIf,
	LogicNot,
	LogicNotEqual,
	LogicNotNot,
	LogicOr,
	LogicStrictEqual,
	LogicStrictNotEqual,
	MiscIn,
	MiscLog,
	MiscMethod,
	NumericGreater,
	NumericGreaterEqual,
	NumericLess,
	NumericLessEqual,
	NumericMax,
	NumericMin,
	StringCat,
	StringSubstr
].reduce((acc, cur) => {
	var s2 = JSON.parse(stripUrl(JSON.stringify(cur)))
	s2.id = s2.$id
	delete s2.$schema
	delete s2.$id
	acc[s2.id] = s2
	return acc
}, {})

function stripUrl(str) {
	return str
		.replace(new RegExp("http://jsonlogic.com/schemas/", "g"), "#")
		.replace(/\.json/g, "")
}
const coverSchema = {
	...jsonLogicSchema,
	$ref: stripUrl(jsonLogicSchema.$ref),
	$id: `a://covergo/${stripUrl(jsonLogicSchema.$id).substr(1)}`,
	definitions
}

export default {
	name: "JsonEditor",
	props: {
		value: {
			type: String,
			default: "{}"
		}
	},

	model: {
		event: "change"
	},

	watch: {
		value(newValue) {
			if (this.editor) {
				const editor = this.getModifiedEditor()
				if (newValue !== editor.getValue()) {
					editor.setValue(newValue)
				}
			}
		}
	},

	mounted() {
		const monaco = require("monaco-editor")
		this.monaco = monaco
		this.initMonaco(monaco)
	},

	beforeDestroy() {
		this.editor && this.editor.dispose()
	},

	methods: {
		initMonaco(monaco) {
			const modelUri = monaco.Uri.parse(
				`a://covergo/json-logic-${Math.random()
					.toString()
					.substr(2, 5)}.json`
			)
			coverSchema.fileMatch = [modelUri.toString()]
			// const options = {
			// 	value: this.value,
			// 	theme: "vs-dark",
			// 	language: "json"
			// }

			var model = monaco.editor.createModel(this.value, "json", modelUri)

			monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
				validate: true,
				enableSchemaRequest: false,
				schemas: [JSON.stringify(coverSchema)]
			})

			this.editor = monaco.editor.create(this.$el, {
				model,
				theme: "vs-dark",
				autoIndent: true,
				automaticLayout: true,
				formatOnPaste: true,
				formatOnType: true
			})

			const editor = this.getModifiedEditor()

			editor.onDidChangeModelContent(event => {
				const value = editor.getValue()
				if (this.value !== value) {
					this.$emit("change", value, event)
				}
			})

			this.$emit("editorDidMount", this.editor)
		},

		getModifiedEditor() {
			return this.editor
		},

		focus() {
			this.editor.focus()
		}
	},
	render(h) {
		return h("div")
	}
}
</script>
